export default "__VITE_ASSET__47dfc755__"